import React from 'react';
import ConnectPage from '../components/ConnectPage';

const GMCConnectPage: React.FC = () => {
  const config = {
    serviceName: 'Google Merchant Center',
    serviceDisplayName: 'Google Merchant Center',
    apiBaseUrl: 'https://api.gmc.cubehq.ai',
    routePath: '/connect/gmc',
    storageKeys: {
      email: 'userEmail',
      returnUrl: 'mcpReturnUrl',
      clientId: 'mcpClientId',
      state: 'mcpState',
      redirectUri: 'mcpRedirectUri',
      codeChallenge: 'mcpCodeChallenge',
    },
    messages: {
      requestAccess: 'Claude is requesting access to your Google Merchant data. Click "Connect" to authenticate.',
      directAccessError: 'This page is only accessible through Claude AI. Please add the Google Merchant connector in Claude to authenticate.',
      connectDescription: 'Connect your Google Merchant account to access your campaigns and data through Claude AI.',
      connectingMessage: 'Connecting...',
      successMessage: 'Successfully connected to Google Merchant account.!',
      errorMessage: 'Failed to connect to Google Merchant Center. Please try again.',
      buttonText: 'Connect Your Google Ads Account',
    },
  };

  return <ConnectPage config={config} />;
};

export default GMCConnectPage;
